<template>

  <el-container id="root_container" style="padding: 0px;margin: 0px; overflow: hidden;">

    <el-header class="headerManu">
      <div style="height: 60px;background-color: transparent;float: left; margin-left: 20px; display: flex;flex-direction: row;justify-content: start;" @click="goHome()">
        <img  :src="logo"  style="float: left;width: 50px;height: 50px;margin-top: 5px;"/>
        <div style="background-color: transparent; color: white; height: 60px; display: flex;flex-direction: column;justify-content: start; padding-left: 10px;">
          <div class="BSD_TITLE">Global Change Risk Map Platform</div>
          <div class="BSD_SUBTITLE">of Population and Economic Systems</div>
        </div>
      </div>
    </el-header>


    <el-main id="router_view" style="background-color: #F5F7FA;width: 100%;height: 500px;text-align: center;">

      <div id="form_container" style="width: 70%;background-color: white;margin-left: 15%;margin-top: 10px;border-radius: 3px;display: flex;flex-direction: row;justify-content: center;">

        <div style="margin-top: 5%;">

          <el-col style="width: 800px; padding: 20px 40px; border: solid 1px lightgrey;border-radius: 3px; height: auto;box-shadow: 0px 0px 5px lightgrey; ">
            <el-row style="background-color: transparent;">
              <p style="height: 30px;line-height: 30px;font-size: 20px; font-weight: bold; font-family: 'Microsoft YaHei'">Feedback</p>
            </el-row>

            <el-row style="margin-top: 20px;">
              <el-input
                type="textarea"
                :autosize="{ minRows: 15, maxRows: 10}"
                placeholder="Please enter your Suggestions and comments"
                v-model="feedbackContent">
              </el-input>

            </el-row>


            <el-row style="margin-top: 30px;">
              <el-col :span="8" style="text-align: left;">
                <el-button style="width: 80%; font-size: 17px; border:solid 1px deepskyblue;" @click="goHome">Back</el-button>
              </el-col>
              <el-col :span="16">
                <el-button type="primary" style="width: 100%; font-size: 17px;"
                           @click="feedbackSubmit" :disabled="feedbackContent==undefined || feedbackContent.length ==0">Submit</el-button>
              </el-col>

            </el-row>

          </el-col>
        </div>

      </div>
    </el-main>

  </el-container>
</template>

<script>

  import { api_bnu_submitFeedback } from "@/api";
  import {Notify} from "vant";

  let bsd_logo =  require( '../../../src/assets/icons/earth.png');
  export default {
    name: "Login",
    data(){
      return {
        logo:bsd_logo,
        loginData:{
          mail:undefined,
          password:undefined
        },
        feedbackContent:undefined
      }
    },
    methods:{

      /**
       *
       * */
      goHome(){
        this.$router.push({path:'/BNUMap/cc'})
      },


      /**
       *
       * */
      feedbackSubmit(){
        api_bnu_submitFeedback({
          email: this.$appStorage.getUserMailbox(),
          feedback:this.feedbackContent
        }).then(res=>{
          const data = res.data;
          console.log("resData = ",data);
          let code = data.code;
          if(parseInt(code)==200000){
            this.$confirm('Submitted successfully!', 'Prompt', {
              confirmButtonText: 'OK',
              type: 'success'
            }).then(() => {
              this.goHome();
            }).catch(() => {

            });
          }
        })
      }
    },

    mounted() {
      document.getElementById("router_view").style.height = document.body.clientHeight - 60 +"px";
      document.getElementById("form_container").style.height = document.body.clientHeight - 60 - 20 +"px";
    }
  }
</script>




<style scoped lang="scss">
@import "BSDMap";

.headerManu{
 cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/BSD/Feedback.vue